import request from '@/utils/request'

export function pager(data) {
  return request({
    url: '/api/tSupplierRest/listAll',
    method: 'post',
    data,
  })
}

export function getProductList(data) {
  return request({
    url: '/api/tSupplierRest/listAll',
    method: 'post',
    data,
  })
}

export function doAdd(data) {
  return request({
    url: '/api/tSupplierRest/',
    method: 'post',
    data,
  })
}

export function doEdit(data) {
  return request({
    url: '/api/tSupplierRest/',
    method: 'put',
    data,
  })
}

export function doDelete(data) {
  return request({
    url: '/api/tSupplierRest/' + data,
    method: 'delete',
  })
}
